function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 6.5C0 2.91015 2.91015 0 6.5 0H25.5C29.0898 0 32 2.91015 32 6.5V25.5C32 29.0898 29.0898 32 25.5 32H6.5C2.91015 32 0 29.0898 0 25.5V6.5Z",
  fill: "#018AE6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 6.5C0 2.91015 2.91015 0 6.5 0H25.5C29.0898 0 32 2.91015 32 6.5V25.5C32 29.0898 29.0898 32 25.5 32H6.5C2.91015 32 0 29.0898 0 25.5V6.5Z",
  fill: "#018AE6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.745 28.4H17.639C16.836 28.3531 16.1617 27.7791 15.987 26.994L12.741 12.394L11.294 16.576C11.0431 17.3005 10.3608 17.7866 9.594 17.787H5.8C4.80589 17.787 4 16.9811 4 15.987C4 14.9929 4.80589 14.187 5.8 14.187H8.311L11.418 5.21098C11.6818 4.4502 12.4187 3.95714 13.2226 4.00364C14.0265 4.05013 14.7017 4.62486 14.876 5.41098L18.128 20.036L19.746 15.396C19.9983 14.673 20.6803 14.1888 21.446 14.189H26.2C27.1941 14.189 28 14.9949 28 15.989C28 16.9831 27.1941 17.789 26.2 17.789H22.724L19.444 27.195C19.1912 27.9168 18.5098 28.4001 17.745 28.4Z",
  fill: "url(#paint0_linear_555:1679)"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_555:1679",
  x1: 6.64,
  y1: 27.0577,
  x2: 28,
  y2: 27.0577,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.75
})));

function SvgIconEquipPulse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEquipPulse);
export default __webpack_public_path__ + "static/media/IconEquipPulse.220d8b97.svg";
export { ForwardRef as ReactComponent };